import styled from 'styled-components';
import ds from '../../utils/designSystem';

export const Navtitle = styled.h1`
  color: red;
`;

export const NavbarMainLink = styled.div`
  font-family: 'Lexend Deca', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: lightgray;
  text-decoration: none;
  margin: 0;
`;

export const NavbarMainDiv = styled.div`
  border-bottom: 1px solid #666666;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: lightgray;
  text-decoration: none;
  padding: 10px;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.6s ease-out;
  background: ${props => (props.active ? ds.colors.black : 'transparent')};
  &:hover {
    background: #075674;
  }
  &:active {
    background: #075674;
  }
`;

//it must be blue if selected
//blue = #075674
export const NavbarChildDiv = styled.div`
  border-bottom: 1px solid #666666;
  background: ${props => (props.active ? ds.colors.blue : ds.colors.gray)};
  color: ${ds.colors.white};
  margin: 0;
  padding: 16px;
  &:hover {
    background: ${ds.colors.blue};
  }
`;

export const NavbarChildLink = styled.div`
  font-family: 'Lexend Deca', sans-serif;
  text-transform: capitalize;
  font-weight: 400;
  padding: 0px;
  margin: 0;
  font-size: 14px;

  a {
    color: lightgray;
  }
`;

export const Icon = styled.span`
  margin-left: 10px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Badge = styled.div`
  display: inline-block;
  min-width: 12px;
  padding: 3px 7px;
  border-radius: 50%;
  font-size: 11px;
  text-align: center;
  background: ${ds.colors.magicPotion};
  color: #fefefe;
`;
